import { userStorageKey } from '../constants/defaultValues';

const storage = localStorage;

export function getRefreshToken() {
    try {
        return storage.getItem(userStorageKey);
    } catch {
        return null;
    }
}

export function setRefreshToken(token) {
    try {
        if (!token) {
            storage.removeItem(userStorageKey);
            return;
        }
        storage.setItem(userStorageKey, token);
    } catch { }
}

export function clearAuthStorage() {
    try {
        storage.removeItem(userStorageKey);
    } catch { }
}
